import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import Container from "@material-ui/core/Container"
import Typography from "../LandingComponents/Typography"

import ProjectContainer from "./ProjectContainer"

const styles = (theme) => ({
  root: {
    //marginTop: theme.spacing(8),
    //marginBottom: theme.spacing(4),
    display: "flex",
    backgroundColor: theme.palette.primary.light,
    overflow: "hidden",
  },
  container: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(15),
    // position: 'relative',
    // display: 'flex',
    // flexDirection: 'column',
    // alignItems: 'center',
  },
})

function ProjectsPage(props) {
  const { classes } = props

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <Typography variant="h4" marked="center" align="center" component="h2">
          Projects
        </Typography>
        <ProjectContainer />
      </Container>
    </section>
  )
}

ProjectsPage.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(ProjectsPage)
